export enum ChartDrillDownTabEnum {
    dashboard = 0,
    mentionList = 1,
    contactOutletList = 2,
    coverageInsights = 3,
    actionAssistant = 4
};
